"use client";

import type { CSSProperties, ReactNode } from "react";

import { BibleReferencesProvider } from "@coisasdoalto/bible-references/react";
import "@coisasdoalto/bible-references/style.css";

// Matches the MUI primary color in src/theme.ts.
const SITE_ACCENT_STYLE = { "--br-accent": "#33691e" } as CSSProperties;

/**
 * Turns Bible references in article text into links with a passage preview.
 * Client-only because the library mounts on the DOM after hydration.
 *
 * Example: <ArticleBibleReferences><div dangerouslySetInnerHTML={...} /></ArticleBibleReferences>
 */
export function ArticleBibleReferences({ children }: { children: ReactNode }) {
  // The site has no dark mode, so the tooltip must not follow the OS theme.
  return (
    <BibleReferencesProvider theme="light" style={SITE_ACCENT_STYLE}>
      {children}
    </BibleReferencesProvider>
  );
}
